import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
// import Home from './pages';
import About from './pages/about';
import Publications from './pages/publications';
import Notes from './pages/notes';
import Overwatch from './pages/posts/overwatch'; 
import Hello from './pages/posts/hello'; 
import Chi2026 from './pages/posts/chi2026'; 
import Hiatus from './pages/posts/hiatus'; 
import Passenger from './pages/posts/passenger'; 
import Playground from './pages/playground';
import Comics from './pages/comics';
import Citations from './pages/posts/citations'; 


function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path='/' element={<About />} />
        <Route path='/comics' element={<Comics />} />
        <Route path='/publications' element={<Publications />} />
        <Route path='/notes' element={<Notes/>} />
        <Route path='/notes/overwatch' element={<Overwatch/>} />
        <Route path='/notes/hello' element={<Hello/>} />
        <Route path='/notes/chi2026' element={<Chi2026/>} />
        <Route path='/notes/citations' element={<Citations/>} />
        <Route path='/notes/hiatus' element={<Hiatus/>} />
        <Route path='/notes/passenger' element={<Passenger/>} />
        <Route path='/playground' element={<Playground/>} />
      </Routes>
    </Router>
  );
}

export default App;
